/* /src/components/auth/silentRenew.jsx */

import React, { useContext, useEffect } from "react";
import { AppContext } from "../../providers/appProvider";

export const SilentRenew = () => {
    const { signinSilentCallback } = useContext(AppContext);

    useEffect(() => {
        console.log("silentRenew");
        signinSilentCallback();
    }, [signinSilentCallback]);

    return <p style={{ width: "100%", textAlign: "center"}}>Завантаження...</p>;
};
